export default __webpack_public_path__ + "static/media/JS.acc4642f.svg";